
export enum RouteTypeCd {
	NOT_ROUTED = 'NotRouted',
	ROUTED = 'Routed',
	STAGED = 'Staged'}

